import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";

function fmt(d) {
  const x = new Date(d);
  return isNaN(x) ? d : x.toLocaleString("it-IT", { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function SignupDatesDialog({ open, onOpenChange, service, slot, onConfirm }) {
  const [sel, setSel] = useState([]);

  useEffect(() => {
    if (open && service) {
      setSel(service.my_dates && service.my_dates.length ? service.my_dates : (service.dates || []));
    }
  }, [open, service]);

  if (!service) return null;
  const mine = new Set(service.my_dates || []);
  const alreadySigned = mine.size > 0;
  const toggle = (d) => setSel((p) => (p.includes(d) ? p.filter((x) => x !== d) : [...p, d]));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{alreadySigned ? "Aggiungi altre date" : "Scegli le date"}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          {alreadySigned
            ? <>Sei già iscritto ad alcune date di «{service.event_name}». Seleziona le nuove date a cui aggiungerti.</>
            : <>Ti iscrivi come <strong>{slot}</strong> a «{service.event_name}». Seleziona una o più date.</>}
        </p>
        <div className="space-y-2" data-testid="signup-dates-list">
          {(service.dates || []).map((d) => (
            <label key={d} className={`flex items-center gap-2 rounded-lg border border-border px-3 py-2 text-sm ${mine.has(d) ? "opacity-60" : "cursor-pointer hover:bg-muted"}`}>
              <Checkbox data-testid={`signup-date-${d}`} checked={sel.includes(d)} disabled={mine.has(d)} onCheckedChange={() => toggle(d)} />
              <span>{fmt(d)}{service.end_times?.[d] ? ` – ${service.end_times[d]}` : ""}{mine.has(d) ? " · già iscritto" : ""}</span>
            </label>
          ))}
        </div>
        <DialogFooter>
          <Button data-testid="confirm-signup-dates" disabled={sel.length === 0 || (alreadySigned && sel.every((d) => mine.has(d)))} onClick={() => onConfirm(sel)} className="rounded-full font-semibold">
            {alreadySigned ? "Aggiungi date" : "Conferma iscrizione"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
